import { SET_AIRPORT_LIST } from "../constant/actionTypes";

const initialState = {
  airports: []
}

export const airportReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_AIRPORT_LIST:
      return (state = { ...state, airports: action.payload });
    default:
      break;
  }
  return state;
}